import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static targets = ["item", "trigger"];
  static values = { openClass: String, hiddenClass: String };

  get hiddenClass() {
    return this.hasHiddenClassValue ? this.hiddenClassValue : "hidden";
  }

  toggle() {
    this.itemTargets.forEach((item) => {
      item.classList.toggle(this.hiddenClass);
    });
    this.syncTrigger();
  }

  show() {
    this.itemTargets.forEach((item) => {
      item.classList.remove(this.hiddenClass);
    });
    this.syncTrigger();
  }

  hide() {
    this.itemTargets.forEach((item) => {
      item.classList.add(this.hiddenClass);
    });
    this.syncTrigger();
  }

  // A Turbo filter submit replaces the trigger but leaves the panel standing, so the
  // server's idea of "open" can disagree with the panel the user actually left open or
  // closed. Re-derive it from the panel here and the markup only supplies a first guess.
  triggerTargetConnected() {
    this.syncTrigger();
  }

  syncTrigger() {
    if (!this.hasTriggerTarget || this.itemTargets.length === 0) return;

    const expanded = this.itemTargets.some((item) => !item.classList.contains(this.hiddenClass));

    if (this.hasOpenClassValue) {
      this.triggerTarget.classList.toggle(this.openClassValue, expanded);
    }
    if (this.triggerTarget.hasAttribute("aria-expanded")) {
      this.triggerTarget.setAttribute("aria-expanded", expanded.toString());
    }
  }
}
